export const STEP_ONE = 1;
export const STEP_TWO = 2;
export const MAX_SQUARE_UNITS = 10000;
